module.exports = __webpack_public_path__ + "img/love_reading.b87df40e.svg";